// admin or user can update calc so
// just using user unstead of targetUserID
export default async function updateCalc(user, calc, data) {
  const createTargetUrl = `${process.env.CMS_URL}/calcs/${calc.id}`;

  let resData;
  const token = await user.getIdToken();

  try {
    const res = await fetch(createTargetUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    resData = await res.json();
  } catch (error) {
    console.log("error updating user profile");
    console.log(error);
  }

  return resData;
}
